import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=1206951e&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=1206951e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206951e",
  null
  
)

export default component.exports